import React, { useEffect, useState } from "react";
import logo from "../../../assets/images/profile-sample.jpg";
import DefaultButton from "../../../components/buttons/defaultButton";
import { HiDownload } from "react-icons/hi";
import DefaultSearchSelectInput from "../../../components/inputs/defaultSearchSelectInput";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
// Note: _fetchClasses import removed as class functionality is not available for HR management system
import { downloadIdentityCard } from "../../../../services/workspace/download.service";
import toast from "react-hot-toast";
import { downloadFile } from "../../../../utils/helper";
import { updateWorkspace } from "../../../../services/workspace/workspace.service";

const IdentityCardTemplates = () => {
  const [selectedCard, setSelectedCard] = useState(0);
  
  const { classes } = useSelector((state) => state.configuration);
  const dispatch = useDispatch();
  const [sections, setSections] = useState([]);
  const [classId, setClassId] = useState(null);
  const [sectionId, setSectionId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [studentsCount, setStudentsCount] = useState(0);

  // Since we removed workspace slice, provide a fallback
  const default_workspace = {
    name: "School"
  };

 

  const cardData = {
    name: "Name",
    class: "10th (A)",
    roll_no: "10A001",
    bloodGroup: "B+",
    dob: "25-01-2015",
    fatherName: "Father Name",
    phone: "+91 9999999999",
    motherName: "Mother Name",
    session: "2025-2026",
    house: "Ambedkar",
    logo: default_workspace?.alternate_logo?.url,
    profile: logo,
    school: {
      name: default_workspace?.name || "Synswift Infotech LLP",
      address: default_workspace?.address || "C-201, Phase 8B, Industrial Area",
    },
  };

  // useEffect(() => {
  //   console.log("classId", classId.students_count
  //   );
  // }, [classId]);

  const handleSelect = (value) => {
    setSelectedCard(value);
    updateTemplate(value);
  };

  const updateTemplate = async (value) => {
    try {

      const payload = {
        default_icard: parseInt(value),
        
      };
      if (default_workspace?.uuid) {
        const response = await updateWorkspace(payload, default_workspace?.uuid);
        if (response) {
          toast.success("Template updated successfully!");
        } else {
          toast.error("Failed to update template!.");
        }
      } else {
        toast.error("Failed to update workspace!.");
      }
    } catch (error) {
      toast.error("Failed to update workspace!.");
    }
  };

  const handleDownload = () => {
    if (!classId ) {
      toast.error("Please select class and section");
      return;
    }
    try {
      setLoading(true);
      const data = {
        class_id: classId.value,
        section_id: sectionId.value,
        type: selectedCard,
      }
     
   
    downloadIdentityCard(data).then((res) => {
      downloadFile(res, "identity_card.zip")
 
      toast.success("Downloading");
      setLoading(false);
      })
    } catch (error) {
      toast.error("Error downloading");
      setLoading(false);
    }  
  }

  useEffect(() => {
    if (default_workspace?.default_icard) {
      setSelectedCard(default_workspace?.default_icard===0?1:default_workspace?.default_icard);
    }
  }, [default_workspace]);

  useEffect(() => {
    if (!classId && !classId?.value) return;
    setSectionId("");
    // Retrieve class data once based on `class_id`
    const classData = classes.find((item) => item.value === classId?.value);
    setStudentsCount(classData?.students_count);
    // Map sections and subjects if classData exists
    const sectionList =
      classData?.sections.map((item) => ({
        value: item.id,
        label: item.name,
        ...item,
      })) || [];
    setSections(sectionList);
  }, [classId]);

  useEffect(() => {
    // dispatch(_fetchClasses());
  }, []);

  return (
    <div className="flex flex-col gap-6">
      <div className="flex md:flex-row flex-col gap-4 md:justify-between justify-start items-end md:items-center">
        <div className="flex flex-row gap-4">
          <DefaultSearchSelectInput
            required
            label={"Class"}
            id={"class_id"}
            name={"class_id"}
            value={classId}
            options={classes}
            onChange={(value) => setClassId(value)}
            customWidth={"customWidth2"}
            lebelVertical={false}
          
          />
          <DefaultSearchSelectInput 
            label={"Section"}
            id={"section_id"}
            name={"section_id"}
            value={sectionId}
            options={sections}
            onChange={(value) => setSectionId(value)}
            customWidth={"customWidth2"}
            lebelVertical={false}
            
          />
        </div>
        <DefaultButton name="Download Zip" loading={loading} onClick={handleDownload} icon={<HiDownload   /> } disabled={studentsCount === 0} />
      </div>

      <div className="grid md:grid-cols-3 grid-cols-1 gap-6">
        <CardType1
          isSelected={selectedCard === 1}
          onChange={() => handleSelect(1)}
          data={cardData}
        />
       
         
          <CardType2
            isSelected={selectedCard === 2}
            onChange={() => handleSelect(2)}
            data={cardData}
          />
         
        <CardType3
          isSelected={selectedCard === 3}
          onChange={() => handleSelect(3)}
          data={cardData}
        />
      </div>
    </div>
  );
};

// ================= Card Type 1 =================
const CardType1 = ({ isSelected, onChange, data }) => (
  <div
    onClick={onChange}
    className="Icard3 relative flex flex-row gap-2 rounded-md items-center justify-between text-theme cursor-pointer w-full"
  >
    <div className={`flex flex-col gap-4 rounded-md p-4 w-full`}>
      <div className="border-b pb-2 flex gap-2 items-center w-full">
        <div className="w-14 h-14 bg-light rounded-md">
          <img
            src={data.logo}
            alt="logo"
            className="w-full h-full object-cover"
          />
        </div>

        <div>
          <h2 className="text-theme font-bold">{data.school.name}</h2>
          <p className="text-textLight font-light">
            {data?.school?.address}{" "}
            {data?.school?.phone ? `| ${data?.school?.phone}` : ""}
          </p>
        </div>
      </div>

      <div className="flex flex-row items-center justify-center gap-2">
        <div className="w-20 h-20 rounded-full overflow-hidden border flex justify-center items-center">
          <img src={data.profile} alt="logo" />
        </div>
      </div>

      <div className="grid grid-cols-2 text-sm text-textLight gap-y-1">
        <div className="font-bold">
          <p>Name</p>
          <p>Class</p>
          <p>Roll No</p>
          <p>Date of Birth</p>
          <p>Father Name</p>
          <p>Mother Name</p>
          <p>Phone</p>
          <p>Blood Group</p>
          <p>Session</p>
          <p>House</p>
        </div>
        <div className="text-right text-theme">
          <p>{data.name}</p>
          <p>{data.class}</p>
          <p>{data.roll_no}</p>
          <p>{data.dob}</p>
          <p>{data.fatherName}</p>
          <p>{data.motherName}</p>
          <p>{data.phone}</p>
          <p>{data.bloodGroup}</p>
          <p>{data.session}</p>
          <p>{data.house}</p>
        </div>
      </div>
    </div>

    {isSelected && (
      <div className="absolute inset-0 rounded-md bg-black/30 flex justify-end z-40 p-4">
        <IoCheckmarkCircleOutline className="text-green-600 text-4xl" />
      </div>
    )}
  </div>
);

// ================= Card Type 2 =================
const CardType2 = ({ isSelected, onChange, data }) => (
  <div
    onClick={onChange}
    className={`Icard2 relative flex flex-col gap-4 p-4 rounded-md border text-theme cursor-pointer`}
  >
    <div className="border-b pb-2 flex gap-2 items-center w-full">
        <div className="w-14 h-14 bg-light rounded-md">
          <img
            src={data.logo}
            alt="logo"
            className="w-full h-full object-cover"
          />
        </div>

        <div>
          <h2 className="text-theme font-bold">{data.school.name}</h2>
          <p className="text-textLight font-light">
            {data?.school?.address}{" "}
            {data?.school?.phone ? `| ${data?.school?.phone}` : ""}
          </p>
        </div>
      </div>

    <div className="flex flex-row gap-6 items-start mt-4">
      <div className="w-28 flex flex-col gap-2">
        <div className="border rounded-md overflow-hidden">
          <img
            src={data.profile}
            alt="Student Profile"
            className="object-cover w-full h-full"
          />
        </div>
        <div>
          <p className="font-bold text-center">{data.name}</p>
          <p className="text-center text-sm">{data.session}</p>
        </div>
      </div>

      <div className="flex flex-col gap-2 flex-1">
        <div className="grid grid-cols-2 gap-x-4 gap-y-1 text-sm text-textLight">
          <div>Class:</div>
          <div className="text-theme">{data.class}</div>
          <div>Roll No:</div>
          <div className="text-theme">{data.roll_no}</div>
          <div>Blood Group:</div>
          <div className="text-theme">{data.bloodGroup}</div>
          <div>DOB:</div>
          <div className="text-theme">{data.dob}</div>
          <div>Father's Name:</div>
          <div className="text-theme">{data.fatherName}</div>
          <div>Phone No:</div>
          <div className="text-theme">{data.phone}</div>
          <div>Mother's Name:</div>
          <div className="text-theme">{data.motherName}</div>
          <div>House:</div>
          <div className="text-theme">{data.house}</div>
        </div>
      </div>
    </div>

    {isSelected && (
      <div className="absolute inset-0 rounded-md bg-black/30 flex justify-end z-40 p-4">
        <IoCheckmarkCircleOutline className="text-green-600 text-4xl" />
      </div>
    )}
  </div>
);

// ================= Card Type 3 =================
const CardType3 = ({ isSelected, onChange, data }) => (
  <div
    onClick={onChange}
    className={`Icard1 relative flex flex-row gap-2 rounded-md border p-4 items-center justify-between text-theme cursor-pointer w-full`}
  >
    <div className="flex flex-col gap-6 w-full">
    <div className="border-b pb-2 flex gap-2 items-center ">
        <div className="w-14 h-14 bg-light rounded-md">
          <img
            src={data.logo}
            alt="logo"
            className="w-full h-full object-cover"
          />
        </div>

        <div>
          <h2 className="text-theme font-bold">{data.school.name}</h2>
          <p className="text-textLight font-light">
            {data?.school?.address}{" "}
            {data?.school?.phone ? `| ${data?.school?.phone}` : ""}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3 items-center">
        <div className="w-28 h-28 rounded-md overflow-hidden">
          <img src={data.profile} alt="logo" />
        </div>
        <div className="flex flex-col flex-1">
          <p className="font-bold">{data.name}</p>
          <p className="text-textLight">Class - {data.class}</p>
          <p className="text-textLight">Roll No - {data.roll_no}</p>
          <p className="text-textLight">Blood Group - {data.bloodGroup}</p>
          <p className="text-textLight">Session - {data.session}</p>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div className="font-bold text-textLight">
          <p>Date of Birth</p>
          <p>Father Name</p>
          <p>Mother Name</p>
          <p>Phone</p>
          <p>House</p>
        </div>
        <div className="text-left text-theme">
          <p>{data.dob}</p>
          <p>{data.fatherName}</p>
          <p>{data.motherName}</p>
          <p>{data.phone}</p>
          <p>{data.house}</p>
        </div>
      </div>
    </div>

    {isSelected && (
      <div className="absolute inset-0 rounded-md bg-black/30 flex justify-end z-40 p-4">
        <IoCheckmarkCircleOutline className="text-green-600 text-4xl" />
      </div>
    )}
  </div>
);

export default IdentityCardTemplates;
